var map = {
	"./ball1": 890,
	"./ball1.png": 890,
	"./ball2": 891,
	"./ball2.png": 891,
	"./ball3": 892,
	"./ball3.png": 892,
	"./ball4": 893,
	"./ball4.png": 893,
	"./ball5": 894,
	"./ball5.png": 894,
	"./ball6": 895,
	"./ball6.png": 895,
	"./bg": 896,
	"./bg.png": 896,
	"./bg_1": 897,
	"./bg_1.png": 897,
	"./bg_2": 898,
	"./bg_2.png": 898,
	"./bg_3": 899,
	"./bg_3.png": 899,
	"./bg_m": 900,
	"./bg_m.png": 900,
	"./footer": 901,
	"./footer.png": 901,
	"./h_logo": 902,
	"./h_logo.png": 902,
	"./hoch": 903,
	"./hoch.png": 903,
	"./ibg": 904,
	"./ibg.png": 904,
	"./knife": 905,
	"./knife.png": 905,
	"./l1": 906,
	"./l1.png": 906,
	"./l2": 907,
	"./l2.png": 907,
	"./l3": 908,
	"./l3.png": 908,
	"./l4": 909,
	"./l4.png": 909,
	"./menu_m": 910,
	"./menu_m.png": 910,
	"./p1": 911,
	"./p1.png": 911,
	"./p2": 912,
	"./p2.png": 912,
	"./snow": 913,
	"./snow.png": 913,
	"./snow2": 914,
	"./snow2.png": 914,
	"./snow3": 915,
	"./snow3.png": 915,
	"./test_m": 916,
	"./test_m.png": 916,
	"./top_m": 917,
	"./top_m.png": 917,
	"./v1": 918,
	"./v1.png": 918,
	"./v2": 919,
	"./v2.png": 919,
	"./v3": 920,
	"./v3.png": 920,
	"./v4": 921,
	"./v4.png": 921,
	"./v5": 922,
	"./v5.png": 922
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2143;